import React from 'react';

import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';

import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import _omit from 'lodash/omit';

import { StylePropType } from 'libs/proptypes';

import StyleConfigurationTableRow from './components/StyleConfigurationTableRow';

import './StyleConfigurationTable.scss';

const propTypes = {
  cssRules: PropTypes.arrayOf(PropTypes.string).isRequired,
  style: StylePropType,
  onChange: PropTypes.func.isRequired,
  labelMap: PropTypes.shape({}),
};

const defaultProps = {
  style: {},
  labelMap: {},
};

export default function StyleConfigurationTable({
  cssRules,
  style,
  onChange: onChangeProp,
  labelMap,
}) {
  function onChange(e, { cssRule, name, checked, value }) {
    let newValue = {};

    if (name === 'enabled') {
      newValue = checked ? { ...style, [cssRule]: '' } : _omit(style, cssRule);
    }
    if (name === 'value') {
      newValue = { ...style, [cssRule]: value };
    }

    const newTarget = { ...e.target, value: newValue };
    onChangeProp({ ...e, target: newTarget }, newTarget);
  }

  if (_isEmpty(cssRules)) {
    return null;
  }

  return (
    <Table celled className="style-configuration-table">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={5}>Name</Table.HeaderCell>
          <Table.HeaderCell width={9}>Value</Table.HeaderCell>
          <Table.HeaderCell width={4}>Enabled</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {cssRules.map((cssRule) => {
          const enabled = _has(style, cssRule);
          const value = enabled ? style[cssRule] : null;

          return (
            <StyleConfigurationTableRow
              key={cssRule}
              rule={cssRule}
              value={value}
              enabled={enabled}
              onChange={onChange}
              labelMap={labelMap}
            />
          );
        })}
      </Table.Body>
    </Table>
  );
}

StyleConfigurationTable.propTypes = propTypes;
StyleConfigurationTable.defaultProps = defaultProps;
